import start from './start';
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./datatables');
require('./set-height');
require('./lightbox');
require ('./tabs');
require('./hotkeys');
require('./menu');

window.Vue = require('vue');
window.moment = require('moment-timezone');
// window.moment.tz.add([
//     'Asia/Tokyo|Japan',
//     'Pacific/Auckland|NZ'
// ])

import axios from 'axios';
import VueAxios from 'vue-axios';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueFilterDateFormat from 'vue-filter-date-format';
import LaravelRouter from './thirdparty/Ziggy/route.js';
import underscore from 'vue-underscore';

import locale from 'element-ui/lib/locale/lang/en';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MyPlugin from './util/vue_plugin';
import 'v-slim-dialog/dist/v-slim-dialog.css';
import SlimDialog from 'v-slim-dialog';
import mouseMenu from 'vue-mouse-menu';
import defaultDateFormat from './mixins/defaultDateFormats';

window.LaravelRouter = LaravelRouter;
window.laravel_route = (name, args) => {
    return LaravelRouter(name, args, true).url();
};
Vue.use(MyPlugin);
Vue.use(ElementUI,{ locale });
Vue.use(underscore);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Multiselect);
Vue.use(VueFilterDateFormat);
Vue.use(SlimDialog);
Vue.use(mouseMenu);

Vue.mixin(defaultDateFormat)


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const search = require('./components/VehicleSearch.vue');
const search_results_page = require('./components/SeachListPage.vue');
const single_vehicle_page =  require('./components/SingleVehicle.vue')
const notifications_page =  require('./components/NotificationsPage.vue')
Vue.component('headertime', require('./components/HeaderTime.vue'));
Vue.component('router-page', require('./components/RouterPage.vue'));
Vue.component('icon', require('./components/Common/Icon.vue'));
Vue.component('vehicle-search', search);
Vue.component('vehicle-search-form', require('./components/Forms/VehicleSearch.vue'));
Vue.component('vehicle-search-list', require('./components/VehicleSearchList.vue'));
Vue.component('parts-search', require('./components/PartsSearch.vue'));
Vue.component('request-vehicle', require('./components/RequestVehicle.vue'));
Vue.component('searchlist-page', search_results_page);
Vue.component('recent-search', require('./components/RecentSearch/RecentSearch.vue'));
Vue.component('my-garage-page', require('./components/MyGarage/MyGaragePage.vue'));
Vue.component('currency-calculator', require('./components/CurrencyCalculator.vue'));
Vue.component('my-recommendations', require('./components/MyRecommendations/MyRecommendationPage.vue'));
Vue.component('recommended-vehicle', require('./components/MyRecommendations/MyRecommendedVehiclePage.vue'));
Vue.component('vehicle-recommendation-modal', require('./components/VehicleRecommendationModal.vue'));
Vue.component('vehicle-send-email-modal', require('./components/VehicleRecommendationSendEmailModal.vue'));
Vue.component('vehicle-recommendation-send-email-modal', require('./components/VehicleRecommendationSendEmailModal'));
Vue.component('send-email', require('./components/SendEmail.vue'));
Vue.component('help-tool-tip', require('./components/HelpToolTip'));
Vue.component('favourite-tag-modal', require('./components/FavouriteTagModal.vue'));
Vue.component('favourite-list-page', require('./components/Favourites/FavouritesListPage.vue'));
Vue.component('single-vehicle-page', single_vehicle_page);
Vue.component('add-new-user-page', require('./components/User/AddUserPage'));
Vue.component('user-update-page', require('./components/User/EditUser'));
Vue.component('user-list-page', require('./components/User/UserListPage'));
Vue.component('user-profile-page', require('./components/User/EditUserProfilePage'));
Vue.component('messages', require('./components/Messages'));
Vue.component('price-list-page', require('./components/PriceRule/ListPage'));
Vue.component('price-add-edit-page', require('./components/PriceRule/CreatePage'));
Vue.component('region-list-page', require('./components/region/ListPage'));
Vue.component('region-add-edit-page', require('./components/region/CreatePage'));
Vue.component('category-list-page', require('./components/Category/ListPage'));
Vue.component('category-add-edit-page', require('./components/Category/CreatePage'));
Vue.component('vehicle-stock-requests-page', require('./components/VehicleStock/RequestsListPage'));
Vue.component('vehicle-stock-list-page', require('./components/VehicleStock/ListPage'));
Vue.component('vehicle-stock-add-edit-page', require('./components/VehicleStock/CreatePage'));
Vue.component('vehicle-stock-show-page', require('./components/VehicleStock/ShowPage'));
Vue.component('translatable-text', require('./components/TranslatableText'));
Vue.component('history-all', require('./components/History/AllHistory'));
Vue.component('history-by-user', require('./components/History/HistoryByUser'));
Vue.component('settings-form', require('./components/Forms/Settings'));
Vue.component('bid-list-page', require('./components/BidsListPage'));
Vue.component('notifications', require('./components/Common/Notifications'));
Vue.component('email-creator', require('./components/EmailCreator/send-email'));
Vue.component('site-settings-auction-alert-banner', require('./components/SiteSettings/AuctionAlertBanner'))
Vue.component('email-list-page', require('./components/EmailRecord/ListPage'));
Vue.component('copy-favourite-list-modal', require('./components/CopyFavListModal.vue'));

Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
        // Focus the element
        el.focus()
    }
})

import store from './store'
import router from './router'
//make sure there's a name and that's it's the same as laravel.
const app = new Vue({
    el: '#app',
    store,
    router
});



// WEBPACK FOOTER //
// ./resources/js/app.js